/**
 * Where the sign-in page sends someone afterwards: back to the Genesis address they asked for (a preview
 * link an AI app gave them, a page in the editor), never to another site. Only a path on this site:
 * printable characters, no second slash or backslash (a browser reads //x and /\x as another site), and
 * not the sign-in page itself.
 */
export const signInNext = (next: unknown): string | null => {
  const value = typeof next === 'string' ? next : '';
  if (!/^\/(?![/\\])[\x21-\x7e]*$/.test(value)) return null;
  if (/^\/(admin\/)?login(?:[/?#]|$)/i.test(value)) return null;
  return value;
};

/** The sign-in address that comes back to this path afterwards. */
export const signInPathFor = (path: string) => (signInNext(path) && path !== '/' ? `/admin/login?next=${encodeURIComponent(path)}` : '/admin/login');
